import { validarJSON } from "./utils";

export const borrarDatosSesion = () => {
    localStorage.clear();    
}

export const getItemDatosSesion = (item) => {
    let data = localStorage.getItem(item);    
    if (data){
        return data;
    }else{
        return undefined;
    }
}

export const existeSesion = () => {
    if (localStorage.length > 0){        
        if(getItemDatosSesion('usuario')!==undefined){
            if(getItemDatosSesion('token')!==undefined){
                if(getItemDatosSesion('sesionExpiraEnSeg')!==undefined){
                    if(getItemDatosSesion('fechaInicSesion')!==undefined){
                        if(getItemDatosSesion('perfil')!==undefined){
                            if (getItemDatosSesion('empresaActual')!==undefined){
                                if(getItemDatosSesion('empresasPerfil')!==undefined){
                                    if(getItemDatosSesion('menu')!==undefined){
                                        return true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }    

    return false;
}

export const setDatosSesion = (item, sesion_data) => {
    localStorage.setItem(item, sesion_data);        
}

export const getItemParametros = (arr_parametros, key_item) => {
    let valor_item;    
    for(let i=0; i<arr_parametros.length; i++){        
        if (arr_parametros[i].parametro.toString().toUpperCase() === key_item.toString().toUpperCase()){
            valor_item = arr_parametros[i].valor;
            break;
        }
    }
    return valor_item;
}

export const getFechaProcesoPorModulo = (modulo) => {
    let fechaProcesoModulo = null;
    
    try {
        let fechasProceso = JSON.parse(localStorage.getItem('fechasProceso'));

        if (Array.isArray(fechasProceso)){
            for(let i=0; i<fechasProceso.length; i++){
                let _fechaProcPorModulo = fechasProceso[i];
                if(validarJSON(_fechaProcPorModulo)){
                    if(_fechaProcPorModulo[modulo]){
                        fechaProcesoModulo = _fechaProcPorModulo[modulo];
                        break;
                    }
                }
            }
        }
    }catch(error){
        console.log(`No se puede recuperar la fecha de proceso del módulo: ${modulo}. Error: ${error}`);
    }

    return fechaProcesoModulo;
}